
























import { Component, Vue, Prop } from "vue-property-decorator";
import ImagePreviewModel from "crop-image/src/ImagePreviewModel";
import ImagePreviewSizeModel from "crop-image/src/ImagePreviewSizeModel";

@Component({
  name: "uc-crop-window"
})
export default class UcCropWindow extends Vue {
  @Prop({ default: "", type: String }) image!: string;
  // @Prop({required: true}) cropParams!: ImagePreviewModel;
  // @Prop({ default: 300, type: Number }) height: number;
  // @Prop({ default: 300, type: Number }) width: number;
  innerImagePreviewSize:ImagePreviewSizeModel
  click() {
    this.$emit("clickImage");
  }
  update(val:any){
    this.innerImagePreviewSize=val
  }
  onClickCancel(){
    this.$emit("clickCancel")
  }
  onClickOk(){
    this.$emit("clickOk",this.innerImagePreviewSize)
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/components/uc-crop-window.vue